<template>
  <div id="video" class="video">
    <!-- 标题 -->
    <div class="video-row">
      <div class="video-header">
        <span v-if="isMobile" style="color:F8F2D8;">{{ $t("video") }}</span>
      </div>
    </div>
    <!-- 视频、fb -->
    <div class="video-row">
      <div v-if="lang == 'th'" class="swiper-box">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              @mouseenter="show_btnPlay = true"
              @mouseleave="show_btnPlay = false"
            >
              <video
                :src="cdnPrefix + '/P20N.mp4'"
                loop="true"
                preload="metadata"
              ></video>
              <div
                v-show="show_btnPlay || !video_isplaying"
                class="btn-play"
                @click="videoPlay($event)"
              >
                <div v-show="video_btnIcon == 'play'" class="play"></div>
                <div v-show="video_btnIcon == 'pause'" class="pause"></div>
              </div>
            </div>
            <div
              class="swiper-slide"
              @mouseenter="show_btnPlay = true"
              @mouseleave="show_btnPlay = false"
            >
              <video
                :src="cdnPrefix + '/p20n_th_01.mp4'"
                loop="true"
                preload="metadata"
              ></video>
              <div
                v-show="show_btnPlay || !video_isplaying"
                class="btn-play"
                @click="videoPlay($event)"
              >
                <div v-show="video_btnIcon == 'play'" class="play"></div>
                <div v-show="video_btnIcon == 'pause'" class="pause"></div>
              </div>
            </div>
            <div
              class="swiper-slide"
              @mouseenter="show_btnPlay = true"
              @mouseleave="show_btnPlay = false"
            >
              <video
                :src="cdnPrefix + '/p20n_th_1025.mp4'"
                loop="true"
                preload="metadata"
              ></video>
              <div
                v-show="show_btnPlay || !video_isplaying"
                class="btn-play"
                @click="videoPlay($event)"
              >
                <div v-show="video_btnIcon == 'play'" class="play"></div>
                <div v-show="video_btnIcon == 'pause'" class="pause"></div>
              </div>
            </div>
            <div
              class="swiper-slide"
              @mouseenter="show_btnPlay = true"
              @mouseleave="show_btnPlay = false"
            >
              <video
                :src="cdnPrefix + '/p20n_th_1227.mp4'"
                loop="true"
                preload="metadata"
              ></video>
              <div
                v-show="show_btnPlay || !video_isplaying"
                class="btn-play"
                @click="videoPlay($event)"
              >
                <div v-show="video_btnIcon == 'play'" class="play"></div>
                <div v-show="video_btnIcon == 'pause'" class="pause"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination page"></div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>

      <div v-else class="swiper-box">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              @mouseenter="show_btnPlay = true"
              @mouseleave="show_btnPlay = false"
            >
              <video
                :src="cdnPrefix + '/P20N.mp4'"
                loop="true"
                preload="metadata"
              ></video>
              <div
                v-show="show_btnPlay || !video_isplaying"
                class="btn-play"
                @click="videoPlay($event)"
              >
                <div v-show="video_btnIcon == 'play'" class="play"></div>
                <div v-show="video_btnIcon == 'pause'" class="pause"></div>
              </div>
            </div>
            <template v-if="lang == 'ja'">
              <div class="swiper-slide">
                <iframe
                  width="100%"
                  height="400"
                  src="https://www.youtube.com/embed/mGzvMIsmsg8?si=yR4qUai73Fm4WtPm"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
              </div>
              <div class="swiper-slide">
                <iframe
                  width="100%"
                  height="400"
                  src="https://www.youtube.com/embed/u0wllf4BA0Y?si=uCdWHdJFNWFlNW6h"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
              </div>
            </template>
            <div
              class="swiper-slide"
              @mouseenter="show_btnPlay = true"
              @mouseleave="show_btnPlay = false"
            >
              <video
                :src="cdnPrefix + '/p20n-1.mp4'"
                loop="true"
                preload="metadata"
              ></video>
              <div
                v-show="show_btnPlay || !video_isplaying"
                class="btn-play"
                @click="videoPlay($event)"
              >
                <div v-show="video_btnIcon == 'play'" class="play"></div>
                <div v-show="video_btnIcon == 'pause'" class="pause"></div>
              </div>
            </div>
            <div
              class="swiper-slide"
              @mouseenter="show_btnPlay = true"
              @mouseleave="show_btnPlay = false"
            >
              <video
                :src="cdnPrefix + '/p20n_JP-2.mp4'"
                loop="true"
                preload="metadata"
              ></video>
              <div
                v-show="show_btnPlay || !video_isplaying"
                class="btn-play"
                @click="videoPlay($event)"
              >
                <div v-show="video_btnIcon == 'play'" class="play"></div>
                <div v-show="video_btnIcon == 'pause'" class="pause"></div>
              </div>
            </div>
            <div
              class="swiper-slide"
              @mouseenter="show_btnPlay = true"
              @mouseleave="show_btnPlay = false"
            >
              <video
                :src="cdnPrefix + '/p20n_JP-3.mp4'"
                loop="true"
                preload="metadata"
              ></video>
              <div
                v-show="show_btnPlay || !video_isplaying"
                class="btn-play"
                @click="videoPlay($event)"
              >
                <div v-show="video_btnIcon == 'play'" class="play"></div>
                <div v-show="video_btnIcon == 'pause'" class="pause"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination page"></div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>

      <div v-if="!isMobile" class="fb-box">
        <div v-if="lang == 'zh-CN'" class="cont">
          <iframe
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fzgbwu%2F&tabs=timeline&width=370&height=390&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true&appId=429620134449094"
            width="360"
            height="390"
            style="border:none;overflow:hidden"
            scrolling="no"
            frameborder="0"
            allowtransparency="true"
            allow="encrypted-media"
          ></iframe>
        </div>
        <div v-if="lang == 'ja'" class="cont">
          <span class="T-title">Twitter</span>
          <a
            class="twitter-timeline"
            data-lang="ja"
            data-width="360"
            data-height="390"
            data-dnt="true"
            data-theme="light"
            data-link-color="#2B7BB9"
            href="https://twitter.com/sengokufubu"
            >Tweets by sengokufubu</a
          >
        </div>
        <div v-if="lang == 'en'" class="cont">
          <iframe
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fsengokufubu.en%2F&tabs=timeline&width=370&height=390&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true&appId=429620134449094"
            width="360"
            height="390"
            style="border:none;overflow:hidden"
            scrolling="no"
            frameborder="0"
            allowtransparency="true"
            allow="encrypted-media"
          ></iframe>
        </div>
        <div v-if="lang == 'th'" class="cont">
          <!-- https://www.facebook.com/sengokufubu.th -->
          <!-- 获取fb插件代码 https://developers.facebook.com/docs/plugins/page-plugin -->
          <iframe
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fsengokufubu.th&tabs=timeline&width=370&height=390&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true&appId"
            width="360"
            height="390"
            style="border:none;overflow:hidden"
            scrolling="no"
            frameborder="0"
            allowtransparency="true"
            allow="encrypted-media"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
// import { widgets } from "../assets/js/widgets.js";
import { getNewsList } from "@/api/article.js";

export default {
  name: "Video",
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    cdnPrefix: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      lang: window.localStorage.getItem("localeLanguage"),
      show_btnPlay: true,
      video_isplaying: false,
      video_btnIcon: "play",
      showNewlist: true
    };
  },
  components: {},
  mounted() {
    this._initSwiper();
    // widgets();
  },
  methods: {
    // 播放视频
    videoPlay(e) {
      if ($(e.currentTarget).prev()[0].paused) {
        $(e.currentTarget)
          .prev()[0]
          .play();
        this.video_isplaying = true;
        this.video_btnIcon = "pause";
      } else {
        $(e.currentTarget)
          .prev()[0]
          .pause();
        this.video_isplaying = false;
        this.video_btnIcon = "play";
      }
    },
    // 暂停视频
    pauseVideo() {
      $("#video .swiper-slide video").each(function() {
        $(this)[0].pause();
      });
      this.video_isplaying = false;
      this.video_btnIcon = "play";
    },
    // Swiper
    _initSwiper() {
      let that = this;
      let mySwiper = new Swiper("#video .swiper-container", {
        initalSlide: 2, //设定初始化时slide的索引，
        // direction: "vertical",//slide的滑动方向
        speed: 500, //滑动速度，开始滑动到结束滑动的时间
        autoplay: 500, //可选选项，自动滑动,值为自动滑动的间隔
        autoplayDisableOnInteraction: false, //操作后是否停止自动滑动
        autoplayStopOnLast: false, //设置为true，切换到最后一个slide时停止自动切换
        grabCursor: true, //拖动时指针会变成抓手形状
        loop: false,
        // 分页器 - 即小圆点
        pagination: {
          el: "#video .swiper-pagination",
          clickable: true, //可点击切换
          type: "bullets" //bullets 圆点（默认） fraction 分式 progressbar 进度条 custom 自定义
        },
        // 左右的切换按钮
        navigation: {
          nextEl: "#video .swiper-button-next",
          prevEl: "#video .swiper-button-prev"
        },
        on: {
          slideChange: function() {
            that.pauseVideo();
          }
        },
        preventClicks: false
      });
    }
  }
};
</script>

<style lang="scss">
.video {
  height: 100%;
  padding: 70px 0 0;
  .video-row {
    width: 100%;
    display: flex;
    justify-content: center;
    .video-header {
      width: 350px;
      height: 100px;
      margin-top: 50px;
      img {
        width: 100%;
      }
    }
    .swiper-box {
      margin: 50px 20px 0;
      width: 700px;
      position: relative;
      padding-top: 20px;
      .swiper-container {
        width: 100%;
        .swiper-wrapper {
          .swiper-slide {
            width: 100%;
            position: relative;
            video {
              height: 400px;
            }
            .btn-play {
              width: 80px;
              height: 40px;
              position: absolute;
              left: 310px;
              top: 180px;
              z-index: 20;
              border-radius: 10px;
              background: rgba(170, 170, 170, 0.3);
              text-align: center;
              line-height: 40px;
              cursor: pointer;
              .play {
                border-top: 12px solid transparent;
                border-left: 23px solid #fff;
                border-bottom: 12px solid transparent;
                border-right: 10px solid transparent;
                position: absolute;
                left: 30px;
                top: 7px;
              }
              .pause {
                width: 33px;
                height: 24px;
                background: url($cdnPrefix+"/imgs/pause.png") center center
                  no-repeat;
                background-size: 100% 100%;
                position: absolute;
                left: 24px;
                top: 7px;
              }
            }
            .btn-play:hover {
              background: rgba(50, 50, 50, 0.5);
            }
          }
        }
      }
      // 分页按钮
      .swiper-pagination {
        width: 100%;
        height: 50px;
        line-height: 50px;
        .swiper-pagination-bullet {
          width: 12px;
          height: 12px;
          margin: 0 5px;
          background: #fff;
          opacity: 0.8;
          transition: all 0.1s linear;
          outline: none;
        }
        .swiper-pagination-bullet-active {
          background: #f00;
        }
      }
      // 翻页按钮
      .swiper-button-prev,
      .swiper-button-next {
        width: 40px;
        height: 40px;
        padding: 5px;
        border-radius: 50%;
        outline: none;
        top: 445px;
        &:hover {
          background-color: rgba(204, 204, 204, 0.5);
        }
      }
      .swiper-button-prev {
        background: url($cdnPrefix+"/imgs/btn_prev.png") center center no-repeat;
        background-size: 20px 30px;
        background-color: rgba(204, 204, 204, 0.3);
        left: 5px;
      }
      .swiper-button-next {
        background: url($cdnPrefix+"/imgs/btn_next.png") center center no-repeat;
        background-size: 20px 30px;
        background-color: rgba(204, 204, 204, 0.3);
        right: 5px;
      }
    }
    .fb-box {
      margin: 50px 20px 0;
      width: 430px;
      color: red;
      text-align: center;
      padding: 60px 5px 10px;
      .cont {
        width: 400px;
        height: 400px;
        border-radius: 5px;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        margin: 0 auto;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .T-title {
          position: absolute;
          top: -40px;
          left: 0;
          width: 100%;
          color: #f6dda7;
          font-size: 24px;
        }
      }
    }
  }
}
// 多语言
.lang-zh-CN {
  .video {
    .video-row {
      .video-header {
        background: url($cdnPrefix+"/imgs/video-text-cn.png") center center
          no-repeat;
        background-size: 100% auto;
      }
      .fb-box {
        background: url($cdnPrefix+"/imgs/facebook-bg.png") center center
          no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
.lang-ja {
  .video {
    .video-row {
      .video-header {
        background: url($cdnPrefix+"/imgs/video-text-ja.png") center center
          no-repeat;
        background-size: 100% auto;
      }
      .fb-box {
        background: url($cdnPrefix+"/imgs/facebook-bg-ja.png") center center
          no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
.lang-en {
  .video {
    .video-row {
      .video-header {
        background: url($cdnPrefix+"/imgs/video-text-en.png") center center
          no-repeat;
        background-size: 100% auto;
      }
      .fb-box {
        background: url($cdnPrefix+"/imgs/facebook-bg.png") center center
          no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
.lang-th {
  .video {
    .video-row {
      .video-header {
        background: url($cdnPrefix+"/imgs/video-text-th.png") center center
          no-repeat;
        background-size: 100% auto;
      }
      .fb-box {
        background: url($cdnPrefix+"/imgs/facebook-bg.png") center center
          no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
@media screen and (max-width: 1170px) {
  .video {
    .video-row {
      .swiper-box {
        width: 600px;
        padding-top: 50px;
        .swiper-container {
          .swiper-wrapper {
            .swiper-slide {
              video {
                height: 338px;
              }
              .btn-play {
                left: 260px;
                top: 160px;
              }
            }
          }
        }
        // 翻页按钮
        .swiper-button-prev,
        .swiper-button-next {
          top: 415px;
        }
      }
    }
  }
}
@media screen and (max-width: 1070px) {
  .video {
    height: auto;
    .video-row {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: auto;
    }
  }
}
// 适配小屏
@media screen and (max-width: 768px) {
  .video {
    height: auto;
    padding: 50px 0;
    background: url($cdnPrefix+"/imgs/bgphone-p20n.png") center top no-repeat;
    background-size: 100%;
    .video-row {
      flex-direction: column;
      .video-header {
        width: 250px;
        height: 60px;
        margin: 20px auto 0;
      }
      .swiper-box {
        width: 500px;
        margin: 0 auto;
        padding: 20px 0 50px;
        .swiper-container {
          width: 100%;
          .swiper-wrapper {
            .swiper-slide {
              width: 100%;
              position: relative;
              video {
                height: 300px;
              }
              .btn-play {
                width: 80px;
                height: 40px;
                position: absolute;
                left: 220px;
                top: 140px;
                z-index: 20;
                border-radius: 10px;
                background: rgba(170, 170, 170, 0.3);
                text-align: center;
                line-height: 40px;
                cursor: pointer;
                .play {
                  border-top: 12px solid transparent;
                  border-left: 23px solid #fff;
                  border-bottom: 12px solid transparent;
                  border-right: 10px solid transparent;
                  position: absolute;
                  left: 30px;
                  top: 7px;
                }
                .pause {
                  width: 33px;
                  height: 24px;
                  background: url($cdnPrefix+"/imgs/pause.png") center center
                    no-repeat;
                  background-size: 100% 100%;
                  position: absolute;
                  left: 24px;
                  top: 7px;
                }
              }
              .btn-play:hover {
                background: rgba(50, 50, 50, 0.5);
              }
            }
          }
        }
        // 分页按钮
        .swiper-pagination {
          width: 500px;
          height: 40px;
          line-height: 40px;
          .swiper-pagination-bullet {
            margin: 0 5px;
            background: #fff;
            opacity: 0.8;
            transition: all 0.1s linear;
            outline: none;
          }
          .swiper-pagination-bullet-active {
            background: #f00;
          }
        }
        // 翻页按钮
        .swiper-button-prev,
        .swiper-button-next {
          top: 350px;
        }
      }
      .fb-box {
        margin: 50px auto 0;
        max-width: 420px;
        padding: 60px 0 10px;
        .cont {
          width: 100%;
        }
      }
      .new-fb-header {
        height: 50px;
        display: flex;
        justify-content: space-around;
        background: url($cdnPrefix+"/imgs/bgphone-new-fb.png") center center
          no-repeat;
        background-size: 100% auto;
        .new-btn,
        .fb-btn {
          line-height: 50px;
          cursor: pointer;
          color: #fff;
          font-weight: bold;
          font-size: 18px;
        }
      }
      .new-fb-cont {
        text-align: center;
        padding: 10px 0;
        .new-fb-item {
          height: 480px;
          .new-list {
            width: 90%;
            margin: 0 auto;
            .header {
              width: 90%;
              margin: 0 auto;
              display: flex;
              justify-content: space-between;
              .type-btn {
                color: #fff4d8;
                background: url($cdnPrefix+"/imgs/sec-btn.png") no-repeat;
                background-size: 100% 100%;
                padding: 10px 0;
                text-align: center;
                cursor: pointer;
                min-width: 20%;
                height: 40px;
                line-height: 20px;
              }
              .type-btn.active {
                background: url($cdnPrefix+"/imgs/sec-btn-active.png") no-repeat;
                background-size: 100% 100%;
              }
            }
            .list {
              margin: 10px 0;
              height: 350px;
              overflow-y: auto;
              .item {
                margin: 5px 0;
                background: url($cdnPrefix+"/imgs/new-item-bg.png") center top
                  no-repeat;
                background-size: 100% 100%;
                padding: 1px 10px 10px;
                text-align: left;
                cursor: pointer;
                .unread {
                  display: block;
                  width: 10px;
                  height: 10px;
                  float: right;
                  background: url($cdnPrefix+"/imgs/new-item-unread.png")
                    no-repeat;
                  background-size: 100% 100%;
                }
                .item-cont {
                  font-weight: bold;
                  .todet {
                    display: block;
                    width: 10px;
                    height: 15px;
                    float: right;
                    background: url($cdnPrefix+"/imgs/new-item-todet.png")
                      no-repeat;
                    background-size: 100% 100%;
                    position: relative;
                    right: 5px;
                    bottom: 3px;
                  }
                }
              }
            }
            .new-footer {
              display: flex;
              justify-content: center;
              .change-page {
                display: flex;
                justify-content: center;
              }
              .change-page span {
                display: block;
                color: #fff;
                padding: 5px 20px;
                margin: 0 10px;
                background: url($cdnPrefix+"/imgs/sec-btn.png") no-repeat;
                background-size: 100% 100%;
                cursor: pointer;
                opacity: 0.8;
              }
              .change-page span:hover {
                opacity: 1;
              }
            }
          }
          .cont {
            padding-top: 20px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 414px) {
  #video {
    padding: 0;
    .video-row {
      .video-header {
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        font-weight: bold;
        color: #f8f2d8;
        background: url($cdnPrefix+"/imgs/bgphone-title.png") center center
          no-repeat;
        background-size: 330px 35px;
        text-align: center;
      }
      .swiper-box {
        width: 90%;
        .swiper-container {
          width: 100%;
          margin-bottom: 5px;
          .swiper-wrapper {
            width: 100%;
            .swiper-slide {
              width: 95%;
              text-align: center;
              video {
                width: 100%;
                height: 100%;
              }
              .btn-play {
                left: 42%;
                top: 44%;
              }
            }
          }
        }
        // 分页按钮
        .swiper-pagination {
          width: 100%;
          .swiper-pagination-bullet-active {
            background: #f00;
          }
        }
        // 翻页按钮
        .swiper-button-prev,
        .swiper-button-next {
          top: 260px;
        }
        .swiper-button-prev {
          left: 40px;
        }
        .swiper-button-next {
          right: 40px;
        }
      }
      .fb-box {
        max-width: 100%;
      }
    }
  }
}
@media screen and (max-width: 375px) {
  #video {
    .video-row {
      .swiper-box {
        // 翻页按钮
        .swiper-button-prev,
        .swiper-button-next {
          top: 240px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Video.vue